<template>
  <div>
    <div v-if="show">
      <NoticeBar />
      <div class="agency-top">
        <img src="../../assets/images/bg_02.jpg" class="img" />
        <div class="agency-t-m">
          <div class="agency-t-m-1"><img :src="this.$store.state.avatar" /></div>
          <div class="agency-t-m-2">
            <p class="u-name">{{ userInfo.username }}</p>
            <div>
              <span class="u-phone" v-if="this.$store.state.phone != '' && this.$store.state.phone != null">{{ this.$store.state.phone }}</span>
              <router-link to="/users/binding" v-else><span class="u-phone">绑定手机号</span></router-link>
              <span class="u-level" v-if="user.is_audit == 1">审核中</span>
              <span class="u-level" v-else>{{ this.$store.state.grade_name }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="agency-a">
        <router-link to="/agency/person">
          <div class="agency-a-l">
            <div class="agency-a-l-left">
              <span>{{ user.person_sum_price }}</span>
              <span>个人订单业绩</span>
            </div>
            <div class="agency-a-l-right">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-jiantou"></use>
              </svg>
            </div>
          </div>
        </router-link>
        <router-link to="/agency/team">
          <div class="agency-a-l agency-a-2">
            <div class="agency-a-l-left">
              <span>{{ user.team_sum_price }}</span>
              <span>团队订单业绩</span>
            </div>
            <div class="agency-a-l-right">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-jiantou"></use>
              </svg>
            </div>
          </div>
        </router-link>
      </div>
      <div class="agency-b">
        <div class="agency-b-left">
          <img src="../../assets/images/bg_02.png" />
        </div>
        <div class="agency-b-right">
          <div class="agency-b-r-li">
            <router-link to="/agency/sell">
              <span class="a-b-r-li-icon">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-dingdan1"></use>
                </svg>
              </span>
              <span class="title">我的经销</span>
            </router-link>
          </div>
          <div class="agency-b-r-li agency-b-r-li-r">
            <router-link to="/agency/share">
              <span class="a-b-r-li-icon">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-zhuceyaoqing"></use>
                </svg>
              </span>
              <span class="title">邀请代理</span>
            </router-link>
          </div>
          <div class="agency-b-r-li" style="margin-top:3%" v-if="userInfo.grade_id == 1 || userInfo.grade_id == 2">
            <router-link to="/agency/teaching">
              <span class="a-b-r-li-icon">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-jiaoxuejiaoyu"></use>
                </svg>
              </span>
              <span class="title">模式讲解</span>
            </router-link>
          </div>
          <!--
          <div class="agency-b-r-li agency-b-r-li-r" style="margin-top:3%" v-if="userInfo.grade_id == 1 || userInfo.grade_id == 2">
            <router-link to="/agency/teaching">
              <span class="a-b-r-li-icon">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-sucai"></use>
                </svg>
              </span>
              <span class="title">素材下载</span>
            </router-link>
          </div>
          -->
        </div>
      </div>
      <div class="agency-d" v-if="user.parent_id != 0">
        <h3 class="h3">推荐人</h3>
        <div class="a-d-m">
          <div class="a-d-m-l"><img :src="user.parent_user.avatar" /></div>
          <div class="a-d-m-r">
            <p>{{ user.parent_user.nickname }}<span>{{ user.parent_user.id }}</span></p>
            <p>{{ user.parent_user.grade.name }}</p>
          </div>
        </div>
      </div>
      <div class="agency-c">
        <h3 class="h3">订单库存</h3>
        <router-link :to="{ path: '/goods/details', query: {id: 4}}">
          <div class="a-c-li">
            <span class="a-c-li-icon">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-RectangleCopy"></use>
              </svg>
            </span>
            <span class="a-c-li-title">我要进货</span>
          </div>
        </router-link>
        <router-link to="/agency/orders">
          <div class="a-c-li">
            <span class="a-c-li-icon">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-dingdan1"></use>
              </svg>
            </span>
            <span class="a-c-li-title">下级订单</span>
          </div>
        </router-link>
      </div>
      <!--
      <div class="agency-c">
        <h3 class="h3">综合</h3>
        <div class="agency-c-d">
          <span>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-89"></use>
            </svg>
          </span>
          <p>业绩</p>
        </div>
        <div class="agency-c-d">
          <span>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-guanli1"></use>
            </svg>
          </span>
          <p>管理</p>
        </div>
        <div class="agency-c-d">
          <span>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-tianchongxing-"></use>
            </svg>
          </span>
          <p>管理</p>
        </div>
      </div>
      -->
    </div>

    <Laod ref="laoding" />
    <Footer />
    <wxNoShare />
  </div>
</template>

<script>
  import { Dialog } from 'vant'

  export default {
    components: {
      [Dialog.Component.name]: Dialog.Component,
    },
    name: 'agency',
    data() {
      return {
        show: false,
        user: [],
        userInfo: this.$store.state
      };
    },
    created() {
      // 判断如果是普通用户并且有升级订单
      if(localStorage.getItem('grade_id') == 4 && localStorage.getItem('upgrade_members_grade_id') != 0){
        Dialog.alert({
          message: '您有未支付的注册、升级订单，请尽快付款！',
        }).then(() => {
          this.$router.push({name: 'orders'})
        })
      }else if(localStorage.getItem('grade_id') == 4){
        Dialog.alert({
          message: '您还未成为VIP会员，无法进代理！',
        }).then(() => {
          this.$router.push({name: 'details.vue'})
        })
      }

      if(this.userInfo.name != null) {
        this.userInfo.username = this.userInfo.name
      }else if(this.userInfo.nickname != null) {
        this.userInfo.username = this.userInfo.nickname
      }
      this.getData()
    },
    methods: {
      getData() {
        this.$api.get('agency', null, r=>{
          this.user = r.data
          this.show = true
          this.$refs.laoding.loadClose()
        })
      }
    }
  }
</script>

<style scoped>
  .agency-t-m{
    width: 90%;
  }
  .agency-a{
    background: #ffffff;
    padding:15px;
    overflow: hidden;
  }
  .agency-a .agency-a-l{
    float: left;
    width: 40%;
    background: #F2F3F5;
    padding:4%;
    border-radius: 5px;
  }
  .agency-a .agency-a-l .agency-a-l-left{
    float: left;
  }
  .agency-a .agency-a-l .agency-a-l-left span{
    display: block;
    color:#646566;
    font-size: 14px;
  }
  .agency-a .agency-a-l .agency-a-l-right{
    float: right;
    font-size: 22px;
  }
  .agency-a .agency-a-2{
    float: right;
  }
  .agency-b{
    padding:15px;
    overflow: hidden;
    margin-top: 10px;
    background: #ffffff;
  }
  .agency-b .agency-b-left{
    float: left;
    width: 30%;
  }
  .agency-b .agency-b-left img{
    width: 100%;
  }
  .agency-b .agency-b-right{
    float: right;
    width: 66%;
  }
  .agency-b .agency-b-right .agency-b-r-li{
    float: left;
    border:1px solid #DCDEE0;
    border-radius: 5px;
    width: 47%;
    text-align: center;
    line-height: 30px;
    font-size: 14px;
  }
  .agency-b .agency-b-right .agency-b-r-li-r{
    float: right;
  }
  .agency-b .agency-b-right .agency-b-r-li .a-b-r-li-icon{
    font-size: 18px;
  }
  .agency-c{
    background: #ffffff;
    overflow: hidden;
    padding:15px;
    margin-top: 10px;
  }
  .agency-c .h3{
    color:#646566;
    margin: 0;
    font-weight: normal;
    font-size: 16px;
    padding-bottom: 10px;
  }
  .agency-c .a-c-li{
    border:1px solid #DCDEE0;
    border-radius: 5px;
    float: left;
    width: 31%;
    text-align: center;
    padding: 10px 0;
    margin-right: 3%;
  }
  .agency-c .a-c-li span{
    display: block;
  }
  .agency-c .a-c-li .a-c-li-icon{
    font-size: 28px;
    color:#646566;
  }
  .agency-c .a-c-li .a-c-li-title{
    font-size: 14px;
    color:#646566;
  }
  .agency-c-d{
    float: left;
    width: 33%;
    text-align: center;
  }
  .agency-c-d span{
    font-size: 28px;
    color:#646566;
  }
  .agency-c-d p{
    color:#646566;
    font-size: 14px;
    margin: 0;
  }
  .agency-d{
    background: #ffffff;
    overflow: hidden;
    padding:15px;
    margin-top: 10px;
  }
  .agency-d .h3{
    color:#646566;
    margin: 0;
    font-weight: normal;
    font-size: 16px;
    padding-bottom: 10px;
  }
  .agency-d .a-d-m{
    overflow: hidden;
  }
  .agency-d .a-d-m .a-d-m-l{
    float: left;
    width: 20%;
    text-align: center;
  }
  .agency-d .a-d-m .a-d-m-l img{
    width: 45px;
    height: 45px;
    border-radius: 45px;
  }
  .agency-d .a-d-m .a-d-m-r{
    float: right;
    width: 80%;
  }
  .agency-d .a-d-m .a-d-m-r p{
    margin: 0;
    font-size: 14px;
    padding-bottom: 2px;
  }
  .agency-d .a-d-m .a-d-m-r span{
    background: #97785494;
    padding:0px 10px;
    border-radius: 10px;
    display: inline-block;
    margin-top: 5px;
    font-size: 14px;
    margin-left: 6px;
  }
  .agency-top .agency-t-m{
    width: 90%;
  }
  .agency-top .agency-t-m .agency-t-m-1{
    width: 65px;
  }
  .agency-top .agency-t-m .agency-t-m-2 .u-name{
    width: auto;
  }
</style>



// WEBPACK FOOTER //
// src/views/agency/index.vue